<div class="container-fluid" id="blog-detail-responsive-wrapper">
  <div class="row">
    <div class="col-md-12 main-blog">
      <div id="main" class="blog-wrapper">
        <div id="primary" class="site-content">
          <div id="content" role="main">
            
            <p *ngIf="loading else blogPost" style="text-align: center; padding: 10px 0;">
              <label>loading ...</label>
            </p>

            <ng-template #blogPost>
              <article class="post clearfix" itemscope itemtype="https://schema.org/BlogPosting" [attr.itemid]="'https://efarm.cm/blog/' + blog.slug + '/' + blog.id">
                <meta itemprop="wordCount" [content]="blog.body.length" />
                
                <header class="clearfix">
                  <h1 class="post-title mt-3" itemprop="name">
                    {{ blog.title }}
                  </h1>
                  
                  <div class="post-meta">
                    <span class="meta-item"><i class="fa fa-calendar"></i> {{ blog.postedAt }}</span>
                    <span class="meta-item">
                      <i class="fa fa-comments"></i> 
                      <span style="margin-left: 5px;" itemprop="commentCount">{{ config.totalItems }}</span> comments
                    </span>
                  </div>

                  <div class="post-thumbnail-container">
                    <img *ngIf="hasImagePath(blog)"
                         [src]="getImageSrc(blog.imagePath) + '?func=cropfit&width=1200&dpr=1.75&bg_colour=auto&trim=0&quality=100'"
                         [alt]="blog.title"
                         class="post-hero-img" />
                  </div>
                </header>

                <div class="post-body" itemprop="articleBody" [innerHTML]="blog.body"></div>

                <p *ngIf="loadingComments else blockComment" style="text-align: center; padding: 10px 0;">
                  <label>loading ...</label>
                </p>

                <ng-template #blockComment>
                  <div class="comment-content mb-5">
                    <div *ngIf="config.totalItems > 0" class="comments-wrapper">
                      <h3>Comments</h3>
                      <ol class="commentlist">
                        <li *ngFor="let comment of comments | paginate: config" class="comment">
                          <div class="comment-inner">
                            <div class="avatar-box">
                              <img src="/assets/images/member1.png" class="avatar" />
                            </div>
                            <div class="comment-text">
                              <p class="meta">
                                <strong>{{ comment.name }}</strong>
                                <span class="sep"> - </span>
                                <time>{{ comment.commentedAt }}</time>
                              </p>
                              <div class="description" [innerHTML]="comment.body"></div>
                            </div>
                          </div>
                        </li>
                      </ol>
                    </div>

                    <div class="comments-form-wrapper mt-4">
                      <h3>Leave a reply</h3>
                      <form [formGroup]="form" (ngSubmit)="saveComment()">
                        <div class="row">
                          <div class="col-12">
                            <label>Email <em class="required">*</em></label>
                            <input type="email" formControlName="email" class="form-control" />
                          </div>
                          <div class="col-12 mt-2">
                            <label>Comment <em class="required">*</em></label>
                            <textarea formControlName="body" rows="5" class="form-control"></textarea>
                          </div>
                          <div class="col-12 mt-3">
                            <button [disabled]="form.invalid || submitting"
                                    *ngIf="user != null else loginBtn"
                                    class="btn btn-success btn-submit-comment"
                                    type="submit">
                                Add comment
                            </button>
                            <ng-template #loginBtn>
                              <a class="btn btn-primary btn-login-full" [href]="'/#/signin?returnUrl=' + currentUrl">Log In and Reply</a>
                            </ng-template>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </ng-template>
              </article>
            </ng-template>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  /* --- BASE FIXES --- */
  #blog-detail-responsive-wrapper {
    overflow-x: hidden !important; /* Prevents the "push to the right" */
    width: 100%;
    word-wrap: break-word;
  }

  .post-hero-img {
    display: block;
    width: 100%;       /* Fill container */
    max-width: 1200px; /* Limit on Web */
    height: auto;      /* Keep aspect ratio (NO CUTTING) */
    margin: 0 auto 20px auto;
  }

  /* --- MOBILE VIEW (Phone) --- */
  @media (max-width: 767px) {
    .container-fluid {
      padding-left: 10px !important;
      padding-right: 10px !important;
    }

    .post-title {
      font-size: 1.5rem !important;
      padding: 0 5px;
    }

    /* Force the image to stay inside the phone screen boundaries */
    .post-hero-img {
      width: 100vw !important; /* Viewport width */
      position: relative;
      left: 50%;
      right: 50%;
      margin-left: -50vw;
      margin-right: -50vw;
      max-width: 100vw !important;
    }

    /* Adjust post body images to never overflow */
    .post-body img {
      max-width: 100% !important;
      height: auto !important;
    }

    /* Comments Mobile Style */
    .comment-inner {
      display: flex;
      gap: 10px;
      margin-bottom: 15px;
    }
    .avatar-box img {
      width: 45px;
      height: 45px;
      border-radius: 50%;
    }
    .btn-submit-comment, .btn-login-full {
      width: 100% !important; /* Big buttons for easy thumb tapping */
    }
    
    .post-meta {
        font-size: 0.85rem;
        color: #777;
        margin-bottom: 15px;
    }
    .meta-item {
        margin-right: 10px;
        display: inline-block;
    }
  }

  /* --- WEB VIEW (Stays as is) --- */
  @media (min-width: 768px) {
    .post-hero-img {
      width: 1200px;
      max-width: 100%;
    }
    .btn-submit-comment {
      width: 200px;
    }
    .comment-inner {
      display: flex;
      gap: 20px;
    }
  }
</style>